import { gql } from "@apollo/client";

export const SIGN_IN = gql`
  mutation login(
    $email: String!
    $password: String!
    $recaptchaToken: String!
    $otpToken: String
  ) {
    login(
      emailAddress: $email
      password: $password
      recaptchaToken: $recaptchaToken
      otpToken: $otpToken
    ) {
      token
      user {
        emailAddress
        firstName
        lastName
        isUppticUser
      }
    }
  }
`;

export const LOGIN_EXTERNAL_OTP = gql`
  mutation loginExternalOTP($token: String!, $otpToken: String!) {
    loginExternalOTP(token: $token, otpToken: $otpToken) {
      token
      user {
        emailAddress
        firstName
        lastName
        isUppticUser
      }
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation resetPassword($email: String!) {
    resetPassword(emailAddress: $email)
  }
`;

export const SET_USER_PASSWORD = gql`
  mutation setUserPassword($token: String!, $password: String!) {
    setUserPassword(token: $token, password: $password) {
      emailAddress
    }
  }
`;
